import type { RouteRecordRaw } from 'vue-router';
import { Urls } from '@/config/Urls';

export const userProfileRoutes: RouteRecordRaw[] = [{
  path: Urls.USER_PROFILE,
  name: 'userProfile',
  redirect: Urls.USER_PROFILE_PROFILE,
  component: () => import('./pages/UserProfileLayout.vue'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'profile',
      name: 'userProfileProfile',
      component: () => import('./pages/UserProfileProfile.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: 'change-password',
      name: 'userProfileChangePassword',
      component: () => import('./pages/UserProfileChangePassword.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: 'theme',
      name: 'userProfileTheme',
      component: () => import('./pages/UserProfileTheme.vue'),
      meta: { requiresAuth: true },
    },
    {
      // Trivium Lite (XP-18 unlock). Open to any authenticated user: the
      // page itself renders the locked state (goal + progress) below the
      // threshold, and the unlock truth stays server-side.
      path: 'interface',
      name: 'userProfileInterface',
      component: () => import('./pages/UserProfileInterface.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: 'changelog',
      name: 'userProfileChangelog',
      component: () => import('./pages/UserProfileChangelog.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: 'notifications',
      name: 'userProfileNotifications',
      // Open to any authenticated user: staff see the shared report feed,
      // others see notifications addressed to them (report outcomes, mentions).
      component: () => import('./pages/UserProfileNotifications.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: 'delete-account',
      name: 'userProfileDeleteAccount',
      component: () => import('./pages/UserProfileDeleteAccount.vue'),
      meta: { requiresAuth: true },
    },
  ]
}];
